import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';

/**
 * Ajustes que solo aplican dentro del WebView de Capacitor. En el navegador no
 * hace nada: la SPA es la misma en los dos sitios.
 *
 * Android 15+ fuerza edge-to-edge, así que el WebView se dibuja detrás de la
 * barra de estado y de la de navegación. El layout reserva ese espacio con
 * `env(safe-area-inset-*)` en `estilos/app.css`; aquí solo se deja la barra de
 * estado transparente (para que el color del header claro se vea debajo) y con
 * iconos oscuros para que contrasten.
 */
export async function configurarNativo(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;

  try {
    await StatusBar.setOverlaysWebView({ overlay: true });
    await StatusBar.setStyle({ style: Style.Light });
  } catch {
    // Sin el plugin nativo (o en una plataforma que no lo trae) el CSS ya deja
    // el contenido dentro de los márgenes seguros; el color de los iconos es lo
    // único que se pierde.
  }
}
